// extracted by mini-css-extract-plugin
export default {"container":"NewTodo_container__OHdKY","button-3":"NewTodo_button-3__ULA-3","focus-visible":"NewTodo_focus-visible__7QCIl","inputNewTodo":"NewTodo_inputNewTodo__Wjw4i"};